import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-delete-form',
  templateUrl: './delete.component.html',
  styleUrls: ['./delete.component.scss'],
})
export class DeleteFormComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
